<template>
    <div>
        <template v-if="sent">
            <div class="sent">
                <svg-mailbox-check />
                <h2>Check your inbox!</h2>
                <p>
                    We have sent a password recovery link to your inbox.<br />
                    Check your email to continue the process.
                </p>
            </div>
        </template>
        <template v-else>
            <h2>
                Forgot password
                <small>Enter your email and we will send you a reset link</small>
            </h2>
            <form @submit.prevent="submit" ref="form" action="auth/lost-password">
                <fieldset>
                    <div :class="{ 'error': errors.email }">
                        <input type="email" v-model="form.email" name="email" placeholder="Email" required />
                        <p v-if="errors.email">{{ errors.email }}</p>
                    </div>
                </fieldset>
                <p>By signing in or creating an account, you agree with our <a href="https://pdfshift.io/terms/" title="Read our Terms of Service">Terms of Service</a> and <a href="https://pdfshift.io/privacy/" title="Read our Privacy policy">Privacy Policy</a>.</p>
                <div class="row">
                    <div class="col-6">
                        <router-link :to="{ name: 'login' }" class="secondary">&lt; Back</router-link>
                    </div>
                    <div class="col-6">
                        <button-loader label="Send" :sending="sending" :disabled="disabled" class="btn-full" />
                    </div>
                </div>
            </form>
        </template>
    </div>
</template>

<script>
import VueForm from '@/plugins/VueForm'
import ButtonLoader from '@/components/ButtonLoader'
import SvgMailboxCheck from '@/assets/images/mailbox-check.svg'

export default {
    components: { ButtonLoader, SvgMailboxCheck },
    mixins: [VueForm],
    data () {
        return {
            form: {
                email: null
            },
            sent: false
        }
    },
    methods: {
        processSubmit (body) {
            this.sent = true
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../public/css/vars';

    form>p {
        text-align:center;
        margin: 0 0 20px;
        font-size: .9em;
        font-style: italic;
    }

    .sent {
        text-align: center;
        animation: .5s ease-in-out 0s 1 forwards fadeInTop;

        svg {
            width: 100px;
            height: 100px;
        }

        h2 { margin: 20px 0 }
        p { color: $text-color-light }
    }
</style>
